import { render, staticRenderFns } from "./featureSwitch.vue?vue&type=template&id=8c7bf6e2&scoped=true&"
import script from "./featureSwitch.vue?vue&type=script&lang=js&"
export * from "./featureSwitch.vue?vue&type=script&lang=js&"
import style0 from "./featureSwitch.vue?vue&type=style&index=0&id=8c7bf6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7bf6e2",
  null
  
)

/* custom blocks */
import block0 from "./featureSwitch.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports